interface PasswordChangeSuccessModalProps {
    isOpen: boolean;
    onConfirm: () => void;
}

export default function PasswordChangeSuccessModal({
    isOpen,
    onConfirm,
}: PasswordChangeSuccessModalProps) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] overflow-y-auto">
            {/* Backdrop */}
            <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />

            {/* Modal */}
            <div className="flex min-h-full items-center justify-center p-4">
                <div className="relative bg-white rounded-2xl shadow-xl p-8 w-full max-w-md text-center transform transition-all">
                    {/* Success Icon */}
                    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100 mb-4">
                        <svg
                            className="h-10 w-10 text-green-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>

                    {/* Title */}
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                        Password Changed Successfully!
                    </h3>

                    {/* Message */}
                    <p className="text-base text-gray-600 mb-6 mt-4">
                        Your password has been updated successfully. You'll need to log in again with your new password.
                    </p>

                    {/* Button */}
                    <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-lg border border-transparent bg-blue-600 px-6 py-3 text-base font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                        onClick={onConfirm}
                    >
                        OK, Log Me Out
                    </button>
                </div>
            </div>
        </div>
    );
}
